import React from "react";
import { ChevronUp, ChevronDown, X, Loader2, CheckCircle2 } from "lucide-react";

interface UploadWidgetHeaderProps {
  activeCount: number;
  uploadingCount: number;
  processingCount: number;
  completeCount: number;
  totalCount: number;
  isMinimized: boolean;
  onToggle: () => void;
  onClose: () => void;
}

const UploadWidgetHeader: React.FC<UploadWidgetHeaderProps> = ({
  activeCount,
  uploadingCount,
  processingCount,
  completeCount,
  totalCount,
  isMinimized,
  onToggle,
  onClose,
}) => {
  const canClose = activeCount === 0;
  const getStatusText = () => {
    if (uploadingCount > 0) {
      return `Uploading ${uploadingCount} ${uploadingCount === 1 ? "item" : "items"}`;
    }
    if (processingCount > 0) {
      return `Processing ${processingCount} ${processingCount === 1 ? "item" : "items"}`;
    }
    if (completeCount === totalCount && totalCount > 0) {
      return `${completeCount} upload${completeCount === 1 ? "" : "s"} complete`;
    }
    return `${totalCount} upload${totalCount === 1 ? "" : "s"}`;
  };

  const getStatusIcon = () => {
    if (activeCount > 0) {
      return <Loader2 className="animate-spin" size={18} />;
    }
    if (completeCount === totalCount && totalCount > 0) {
      return <CheckCircle2 className="text-green-500" size={18} />;
    }
    return null;
  };

  return (
    <div className="flex items-center justify-between px-4 py-3 bg-gray-50 border-b border-gray-200">
      <button
        onClick={onToggle}
        className="flex items-center gap-2 flex-1 text-left"
      >
        {getStatusIcon()}
        <span className="text-sm font-medium text-gray-700">
          {getStatusText()}
        </span>
        {isMinimized ? (
          <ChevronUp size={18} className="text-gray-400" />
        ) : (
          <ChevronDown size={18} className="text-gray-400" />
        )}
      </button>

      {canClose && (
        <button
          onClick={onClose}
          className="text-gray-400 hover:text-gray-600 p-1 rounded hover:bg-gray-200"
          title="Close"
        >
          <X size={18} />
        </button>
      )}
    </div>
  );
};

export default UploadWidgetHeader;
